import React from 'react'

const Label = ({ text = '', required = false }) => {
  const className = `label-text ${required ? 'required' : ''}`
  return <label className={className}>{text}</label>
}

export default Label
